import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useBuildMonarchURL, useBuildRecognizeURL } from '@bonusly/url';
import { useCurrentUser } from '@bonusly/who-am-i';

import { AppPath, Route } from '../../config/router';
import { useIsRecognize } from '../../hooks/useIsRecognize';
import { LinkButton } from '../Link';

export const NavMenuAdminButton: FC = () => {
	const recognizeURL = useBuildRecognizeURL();
	const monarchURL = useBuildMonarchURL();
	const { t } = useTranslation('navigation');
	const isRecognize = useIsRecognize();
	const user = useCurrentUser();
	const { awards_admin, finance_admin, global_admin, rewards_admin, tech_admin } = user;

	const linkPath = () => {
		switch (true) {
			// NOTE: global and finance are checked first because if a user has multiple roles we want to link to the dashboard
			case global_admin:
			case finance_admin:
				return isRecognize ? monarchURL(AppPath.AdminDashboard) : AppPath.AdminDashboard;

			case rewards_admin:
				return isRecognize ? monarchURL(AppPath.AdminRewardsCatalog) : AppPath.AdminRewardsCatalog;

			case awards_admin:
				return isRecognize ? Route.AdminAwards : recognizeURL(Route.AdminAwards);

			case tech_admin:
				return isRecognize ? Route.Integrations : recognizeURL(Route.Integrations);

			default:
				return isRecognize ? monarchURL(AppPath.AdminDashboard) : AppPath.AdminDashboard;
		}
	};

	return (
		<LinkButton
			to={linkPath()}
			data-testid="admin-menu-button"
			color="white"
			width="100%"
			height="max-content"
			textAlign="center"
			_active={{ backgroundColor: 'blue.700', color: 'white !important' }}
			_hover={{ backgroundColor: 'blue.600', color: 'white !important' }}
		>
			{t('admin_menu.manage_button')}
		</LinkButton>
	);
};
